import { Box, Flex, Heading, HStack, IconButton } from '@chakra-ui/react'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import { devicesApi } from '~/apis/devicesApi'
import { useUserState } from '~/atoms/UserState'
import { UnsavedChangesDialog } from '~/components/shared/UnsavedChangesDialog'
import { toaster } from '~/components/ui/toaster'
import { ApplicationRoutes } from '~/types/RoutingTypes'

import { DeviceEditPage as DeviceEditPageLib } from '@mangovoice/devices-ui'

export const DeviceEditPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const params = useParams<{ deviceId: string }>()
  const { pbxId, userRoles } = useUserState({ canAutoRefresh: false })
  const deviceId = params.deviceId ? parseInt(params.deviceId, 10) : 0
  const safePbxId = pbxId ?? 0
  const isInternalUser = Boolean(userRoles?.is_staff || userRoles?.is_superuser)

  if (!safePbxId) return null

  return (
    <Flex direction="column" h="full">
      <HStack px={6} py={3} gap={2} flexShrink={0}>
        <IconButton
          variant="ghost"
          size="sm"
          onClick={() => navigate(ApplicationRoutes.DEVICES)}
          aria-label={t('common.back', 'Back')}
        >
          <ArrowLeft />
        </IconButton>
        <Heading size="md">{t('devices.edit.heading', 'Edit Device')}</Heading>
      </HStack>
      <Box flex={1} overflow="auto">
        <DeviceEditPageLib
          api={devicesApi}
          pbxId={safePbxId}
          deviceId={deviceId}
          navigate={navigate}
          toast={toaster}
          listRoute={ApplicationRoutes.DEVICES}
          UnsavedChangesDialog={UnsavedChangesDialog}
          showInternalFields={isInternalUser}
          t={t}
        />
      </Box>
    </Flex>
  )
}
